import { render, staticRenderFns } from "./UserNode.vue?vue&type=template&id=e4d7bfe6&scoped=true"
import script from "./UserNode.vue?vue&type=script&lang=js"
export * from "./UserNode.vue?vue&type=script&lang=js"
import style0 from "./UserNode.vue?vue&type=style&index=0&id=e4d7bfe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d7bfe6",
  null
  
)

export default component.exports